import { useTranslation } from "@/shared/providers/LanguageProvider";
import { NavLink } from "./NavLink";

type NavSectionBlockProps = {
  section: NavSection;
};

export function NavSectionBlock({ section }: NavSectionBlockProps) {
  const { t } = useTranslation();

  return (
    <div>
      {section.titleKey && (
        <p className="mb-2 px-3 text-[10px] font-bold uppercase tracking-[0.14em] text-sidebar-muted">
          {t.safecheck.nav[section.titleKey as SafecheckNavKey]}
        </p>
      )}
      <nav className="space-y-1">
        {section.items.map((item) => (
          <NavLink key={item.id} item={item} />
        ))}
      </nav>
    </div>
  );
}
